export var PHONE_CREATE_CONFIRMATION = 'PHONE_CONFIRMATION';
export var SUCCESS_PHONE_CREATE_CONFIRMATION = 'SUCCESS_PHONE_CREATE_CONFIRMATION';
export var FAILURE_PHONE_CREATE_CONFIRMATION = 'FAILURE_PHONE_CREATE_CONFIRMATION';
export var PHONE_CONFIRM = 'PHONE_CONFIRM';
export var SUCCESS_PHONE_CONFIRM = 'SUCCESS_PHONE_CONFIRM';
export var FAILURE_PHONE_CONFIRM = 'FAILURE_PHONE_CONFIRM';



// WEBPACK FOOTER //
// ./src/actions/phoneConfirmation.js